export const getJWPlayer = ( id: string ) => {
  const player = window.jwplayer && window.jwplayer( id );

  if ( !player || !player.id ) return null;

  return player;
};
